import { render } from "./ProductData.vue?vue&type=template&id=a8046240"
import script from "./ProductData.vue?vue&type=script&lang=js"
export * from "./ProductData.vue?vue&type=script&lang=js"

import "./ProductData.vue?vue&type=style&index=0&id=a8046240&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__